const DOMAIN_REGEX = /(\.global)?\.snowflakecomputing\.com\/?.*$/i;
const APP_DOMAIN_REGEX = /\/([^/]+)\/([^/]+)\/.*$/i;

export function parseSnowflakeAccountName(value: string) {
    try {
        const url = new URL(value);
        // https://ej3564.us-central1.gcp.snowflakecomputing.com/console/login
        if (url.hostname.includes('snowflakecomputing.com')) {
            return url.host.replace(DOMAIN_REGEX, '');
        }
        // https://app.snowflake.com/us-west-2/datameer/worksheets
        if (url.hostname.includes('app.snowflake.com')) {
            if (url.pathname.includes('us-west-2')) {
                // https://docs.snowflake.com/en/user-guide/admin-account-identifier.html#non-vps-account-locator-formats-by-cloud-platform-and-region
                return url.pathname.replace(APP_DOMAIN_REGEX, '$2');
            }
            // https://app.snowflake.com/us-east-1/datameer/worksheets
            return url.pathname.replace(APP_DOMAIN_REGEX, '$2.$1');
        }
        return value.trim();
    } catch {
        const trimmedValue = value.trim();
        if (trimmedValue.includes('snowflakecomputing.com')) {
            return trimmedValue.replace(DOMAIN_REGEX, '');
        }
        return trimmedValue;
    }
}
